/**
 * Created by eungkyu on 2015. 8. 23..
 */
(function(window, angular, undefined) {
    'use strict';

    var m = angular.module('vvCommon');
    m.service('vvL10n', function() {
        // 언어별 페북 결과의 gender가 다 달라서 공통 처리를 위해 새로운 언어 추가시 테스트 해보고 여기에 추가
        // 언어 순서 (편집 편의상): en, kr, la, br, id, vn, th, jp (tw, cn 동일), ru, my, fr, de, it, nl, fi, tr, sv, da, no, ph
        this.fbMaleGenders = ['male', '남성', 'hombre', 'masculino', 'laki-laki', 'nam', 'เพศชาย', '男性', 'мужской', 'lelaki', 'homme', 'männlich', 'uomo', 'man', 'mies', 'erkek', 'man', 'mand', 'mann', 'male'];
        this.fbFemaleGenders = ['female', '여성', 'mujer', 'feminino', 'perempuan', 'nữ', 'หญิง', 'เพศหญิง', '女性', 'женский', 'perempuan', 'femme', 'weiblich', 'donna', 'vrouw', 'nainen', 'kadın', 'kvinna', 'kvinde', 'kvinne', 'female'];

        this.languageFiles = {
            zh_TW: {
                m:     "/json/languages/m/zh_TW.json?_hv=5a63fd6",
                admin: "/json/languages/admin/zh_TW.json?_hv=446d2fe"
            },
            zh_CN: {
                m:     "/json/languages/m/zh_CN.json?_hv=265d799",
                admin: "/json/languages/admin/zh_CN.json?_hv=00b7c15"
            },
            ja: {
                m:     "/json/languages/m/ja.json?_hv=ac0978f",
                admin: "/json/languages/admin/ja.json?_hv=d27e936"
            },
            pt: {
                m:     "/json/languages/m/pt.json?_hv=99f64c4",
                admin: "/json/languages/admin/pt.json?_hv=0f24e5d"
            },
            id: {
                m:     "/json/languages/m/id.json?_hv=f62276e",
                admin: "/json/languages/admin/id.json?_hv=5e9995b"
            },
            vi: {
                m:     "/json/languages/m/vi.json?_hv=77dbeed",
                admin: "/json/languages/admin/vi.json?_hv=53f8198"
            },
            th: {
                m:     "/json/languages/m/th.json?_hv=0cddbbb",
                admin: "/json/languages/admin/th.json?_hv=fc63fb6"
            },
            es: {
                m:     "/json/languages/m/es.json?_hv=0b8ecc3",
                admin: "/json/languages/admin/es.json?_hv=6b3853a"
            },
            fr: {
                m:     "/json/languages/m/fr.json?_hv=2d108ef",
                admin: "/json/languages/admin/fr.json?_hv=ba0d5ba"
            },
            it: {
                m:     "/json/languages/m/it.json?_hv=acd9d1c",
                admin: "/json/languages/admin/it.json?_hv=d4b24f6"
            },
            en: {
                m:     "/json/languages/m/en.json?_hv=9d7d4d4",
                admin: "/json/languages/admin/en.json?_hv=600d631"
            },
            ko: {
                m:     "/json/languages/m/ko.json?_hv=dd3b1a1",
                admin: "/json/languages/admin/ko.json?_hv=cf58b97"
            },
            ph: {
                m:     "/json/languages/m/ph.json?_hv=fb1dd69",
                admin: "/json/languages/admin/ph.json?_hv=4c931a3"
            }
        };
    });
})(window, window.angular);
